/**
 * Centralized file for checkout/provisioning experience.
 * Use these constants instead of hard coding text
 * so wording changes can be made in one place.
 */

export const CHECKOUT_CONFIG = {
  REVIEW_TITLE: 'Checkout',
  REVIEW_SUBTITLE: 'Please review and confirm details to finalize warranty purchase.',
  COMPLETION_TITLE: 'Thank you for your purchase!',
  BUDCO_PAYMENT_TITLE: 'Pay with Budco Financial Services (BFS)',
  BUDCO_PAYMENT_DESCRIPTION:
    'Pay in full now or finance through Budco Financial Services (BFS) with a down payment and monthly installments.',
  BUDCO_MIN_DOWN_PAYMENT_PERCENT: 0.15,
  BUDCO_MIN_TERM_MONTHS: 1,
  BUDCO_MAX_TERM_MONTHS: 18,
  PAY_LATER_TITLE: 'Confirm without payment',
  PAY_LATER_DESCRIPTION:
    'You are confirming this warranty without providing payment now. No payment method is required — the warranty will be provisioned and payment can be arranged separately.',
  CHANGE_PAYMENT_OPTION_TITLE: 'Choose a different payment option',
  LEMUR_PAYMENT_TITLE: 'Finance with Lemur',
  LEMUR_PAYMENT_DESCRIPTION:
    'Apply for financing without WarrantySphere storing your date of birth, government ID, income, housing, or employment details.',
  LEMUR_SUBMIT_LABEL: 'Submit financing application',
  LEMUR_CONSENT_LABEL: 'I have read and accept the Lemur disclosure shown above',
  LEMUR_HOUSING_STATUSES: ['rent', 'own_with_mortgage', 'own_outright'] as const,
  LEMUR_EMPLOYMENT_STATUSES: ['employed', 'self_employed', 'retired', 'military', 'not_employed', 'other'] as const,
  MULTI_PHASE_TITLE: 'Multi-Phase Payment',
  MULTI_PHASE_DESCRIPTION:
    'Split the installments into two phases with separate payment methods — e.g. the seller covers the first installments and the customer pays the remainder.',
  MULTI_PHASE_PHASE_ONE_TITLE: 'Phase 1',
  MULTI_PHASE_PHASE_TWO_TITLE: 'Phase 2',
  MULTI_PHASE_INSTALLMENTS_LABEL: (total: number) => `Phase 1 installments (of ${total})`,
  MULTI_PHASE_INSTALLMENTS_HINT: (max: number) => `Enter 1–${max}. Phase 2 covers the remainder.`,
  MULTI_PHASE_INSTALLMENTS_ERROR: (max: number) =>
    `Phase 1 must be a whole number between 1 and ${max} so Phase 2 keeps at least one installment.`,
  MULTI_PHASE_METHOD_REQUIRED_ERROR: 'Select a payment method for this phase, or choose Bill To.',
  MULTI_PHASE_PHASE_TWO_METHOD_REQUIRED_ERROR: 'Select a payment method for Phase 2.',
  MULTI_PHASE_SELLER_PAYS_LABEL: 'Seller pays this phase',
  MULTI_PHASE_METHOD_OPTION_TITLE: 'Payment method',
  MULTI_PHASE_BILL_TO_TITLE: 'Bill To',
  MULTI_PHASE_BILL_TO_DESCRIPTION:
    'No payment method will be charged for Phase 1 — its installments are billed to the selected party and settled outside of checkout.',
  MULTI_PHASE_PHASE_TWO_DESCRIPTION: 'Automatically covers all remaining installments.',
  MULTI_PHASE_PHASE_TWO_COUNT: (covered: number, total: number) =>
    `Automatically covers the remaining ${covered} of ${total} installments.`,
} as const;
